module.exports = __webpack_public_path__ + "img/stock0.9b7f9cd9.png";